import { render, staticRenderFns } from "./profileView.vue?vue&type=template&id=c7a972c0&scoped=true"
import script from "./profileView.vue?vue&type=script&lang=js"
export * from "./profileView.vue?vue&type=script&lang=js"
import style0 from "./profileView.vue?vue&type=style&index=0&id=c7a972c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a972c0",
  null
  
)

export default component.exports